//
//
//
//
//
//
//
//
//
//

export default {
  name: 'CyFooter'
}



// WEBPACK FOOTER //
// ./src/components/mobile/CyMobileFooter.vue